import { Helmet } from "react-helmet-async";
import homeOgImage from "../assets/images/og/home-og-swiftmaze.jpg";

export default function HomeSEO() {
  const canonical = "https://www.swiftmazetech.com";
  const ogImage = `https://www.swiftmazetech.com${homeOgImage}`;
  const description = "SwiftMaze Tech is a website development and digital marketing company in Modasa that helps local businesses grow with steady results.";

  return (
    <Helmet>
      <title>Website Development & Digital Marketing Company | SwiftMaze Tech</title>

      <meta 
        name="description" 
        content={description}
      />
      <meta name="robots" content="index,follow" />

      <link 
        rel="canonical" 
        href={canonical}
      />
      <meta property="og:title" content="Website Development & Digital Marketing Company | SwiftMaze Tech" />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="website" />
      <meta property="og:image" content={ogImage} />
      <meta property="og:url" content={canonical} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="Website Development & Digital Marketing Company | SwiftMaze Tech" />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
    </Helmet>
  );
}
